import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "find-doctor-page" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "doctor-list pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DoctorCard = _resolveComponent("DoctorCard")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          class: "back-button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
        }, _cache[1] || (_cache[1] = [
          _createElementVNode("i", { class: "pi pi-chevron-left" }, null, -1)
        ])),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-100" }, [
          _createElementVNode("h3", {
            class: "page-title text-center pt-3",
            style: {"line-height":"1"}
          }, " Запись на прием "),
          _createElementVNode("p", {
            class: "page-subtitle text-center",
            style: {"line-height":"1"}
          }, " выберите врача ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.doctors, (doctor) => {
          return (_openBlock(), _createBlock(_component_DoctorCard, {
            class: "mb-2",
            key: doctor.id,
            doctor: doctor,
            onClick: ($event: any) => (_ctx.goToDetails(doctor.id))
          }, null, 8, ["doctor", "onClick"]))
        }), 128))
      ])
    ])
  ]))
}